<template>
  <div id="app" v-if="init">
    <TopNav v-if="!hideNav"></TopNav>
    
    <div class="content">
      <router-view/>
    </div>

    <WebFooter v-if="!hideFooter">

    </WebFooter>

    <Transition name="fade">
      <div class="loading-mask" v-if="isStoreBusy">
        <b-spinner></b-spinner>
      </div>
    </Transition>
  </div>
</template>

<script>
import TopNav from './components/nav/TopNav';
import WebFooter from './components/footer/WebFooter.vue';
import { mapActions, mapGetters, mapState } from 'vuex';

import moment from 'moment';
moment.locale('zh-tw');

export default {
  name: 'AppView',
  metaInfo() {
    const desc = `L'tas 拉塔斯點心舖｜企業送禮與活動客製首選。專業提供商務大宗採購、品牌聯名點心及彌月、派對客製化禮盒。每季推出限量主題，堅持職人手作溫度。無論是企業公關送禮或個人重要時刻，我們都能為您量身打造專屬美味。立即洽詢客製方案。`;
    const url = `${process.env.VUE_APP_WEBDOMAIN}${this.$route.fullPath}`;
    const title = '';
    return {
      title: '',
      titleTemplate: '%sL\'TAS 拉塔斯點心舖',
      meta: [
        { "http-equiv": 'Cache-control', content: 'public' },
        { property: 'og:type', content: 'website' },
        { property: 'og:locale', content: 'zh-tw' },

        { itemprop: 'name', content: title },
        { name: 'description', content: desc },
        { property: 'og:title', content: title },
        { property: 'og:description', content: desc },
        { property: 'og:site_name', content: title },
        { property: 'og:url', content: url },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: desc },
        { name: 'twitter:card', content: 'summary' },
      ],
      link: [
        { rel: 'canonical', href: url },
      ]
    };
  },  
  data() {
    return {
      init: true,
    };
  },
  async mounted() {
    // try {
    //   await this.$store.dispatch('auth/initLoginToken');
    //   this.init = true;
    // } catch(e) {
    //   console.error(e);
    // }
    this.readCartFromStorage();
    window.addEventListener("resize", this.resizeHandler);
    document.dispatchEvent(new Event('render-event'));
    this.detectMALinkAndSetCookie();
  },
  created() {
    window.addEventListener("resize", this.resizeHandler);
    this.resizeHandler();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  components: {
    TopNav,
    WebFooter,
  },
  watch: {
    $route(to) {
      if (to.meta.noToTop === undefined || !to.meta.noToTop) {
        window.scrollTo(0,0);
      }
      // console.log(to);
    }
  },
  computed: {
    ...mapGetters(['isStoreBusy', 'auth/hasToken']),
    ...mapState(['hideNav', 'hideFooter']),
    // routeName() {
    //   return this.$route.name;
    // },
  },
  methods: {
    ...mapActions(['appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg']),
    ...mapActions('cart', ['readCartFromStorage']),
    resizeHandler() {
      this.$store.commit('SETWINDOWWIDTH', window.innerWidth);
    },
    detectMALinkAndSetCookie() {
      const urlParams = new URLSearchParams(window.location.search);
      const rid = urlParams.get('RID');
      const clickId = urlParams.get('Click_ID');

      if (rid && clickId) {
        this.$cookies.set('RID', rid, '1D');
        this.$cookies.set('Click_ID', clickId, '1D');
      }
    }
  }
}
</script>


<style lang="scss" scoped>

.loading-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #0005;
  opacity: 1;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s ease;
}


</style>

<style>
#app {
  color: #333333;
}
</style>